// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tip01[data-v-1442a665] {\n  background-color: #e6f1fe;\n  color: #409eff;\n  padding: 8px 10px;\n  font-size: 14px;\n  border-radius: 5px;\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
